import { Routes } from '@angular/router';

import { roleGuard } from '../../core/guards/role.guard';
import { RoleCode } from '../../shared/models/user/user.enums';

export const reportsRoutes: Routes = [
	{
		path: 'reports',
		children: [
			{
				path: 'requisitions-view',
				canMatch: [roleGuard],
				data: { allowedRoles: [RoleCode.ADMIN, RoleCode.SUPER_ADMIN] },
				loadComponent: () =>
					import('./pages/requisitions-view/requisitions-view-page.component').then(c => c.RequisitionsViewPageComponent)
			},
			{
				path: 'requisitions-cost',
				canMatch: [roleGuard],
				data: { allowedRoles: [RoleCode.ADMIN, RoleCode.SUPER_ADMIN] },
				loadComponent: () =>
					import('./pages/requisitions-cost/requisitions-cost-page.component').then(c => c.RequisitionsCostPageComponent)
			},
			{
				path: 'requisitions-cost-dashboard',
				canMatch: [roleGuard],
				data: { allowedRoles: [RoleCode.ADMIN, RoleCode.SUPER_ADMIN, RoleCode.APPROVER, RoleCode.CC_VIEWER, RoleCode.LEAD_HAND, RoleCode.SUPERVISOR, RoleCode.WAREHOUSE_PERSONNEL] },
				loadComponent: () =>
					import('./pages/requisitions-cost-dashboard/requisitions-cost-dashboard-page.component').then(c => c.RequisitionsCostDashboardPageComponent)
			}
		]
	}
];
